import { render, staticRenderFns } from "./FattureProduzione.vue?vue&type=template&id=19efd7c6"
import script from "./FattureProduzione.vue?vue&type=script&lang=js"
export * from "./FattureProduzione.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports